import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';

import { CREATE_NEW_USER, CREATE_NEW_USER_SUCCESS, CREATE_NEW_USER_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* createUser({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/facilities`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: CREATE_NEW_USER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CREATE_NEW_USER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_NEW_USER_ERROR, payload: error });
  }
}

export function* watchCreateUser() {
  yield takeEvery(CREATE_NEW_USER, createUser);
}

function* createUserSaga() {
  yield all([fork(watchCreateUser)]);
}

export default createUserSaga;
